<template>
  <div>
    <notifications></notifications>

    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-6 text-right">
          <div class="box-buttons">
            <base-button
              type="primary"
              :disabled="disabledButtonSaveProfile"
              @click="saveProfile()"
              class="min-button"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Apply changes</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="row">
        <div class="col-xl-3 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="card p-card">
            <div class="row justify-content-center">
              <div class="col-lg-12 col-md-12">
                <div class="imageload3">
                  <div class="image">
                    <div
                      v-if="url_picture"
                      v-bind:style="{
                        backgroundImage: 'url(' + url_picture + ')'
                      }"
                      class="imgprofile"
                    ></div>

                    <div
                      v-else
                      :style="{ backgroundImage: 'url(' + imgprofile + ')' }"
                      class="imgprofile"
                    ></div>
                  </div>
                </div>

                <div class="mt-3 box-profile-one">
                  <h2 class="subtitle capitalize text-center">
                    {{ first_name }} {{ last_name }}
                  </h2>

                  <span class="role">{{
                    user.agreement.position | typePosition
                  }}</span>
                  <div class="d-xl-block d-lg-none">
                    <div class="content">
                      <div class="mb-3">
                        <span class="role-table"> Birthday</span>

                        <span>
                          {{
                            user.personal_info.date_of_birth | formatDate
                          }}</span
                        >
                      </div>

                      <div class="mb-3">
                        <span class="role-table"> Gender</span>
                        <span> {{ user.personal_info.gender | gender }}</span>
                      </div>

                      <div class="mb-3">
                        <span class="role-table">Contact Number</span>

                        <span>
                          <a href="tel:+54 341 220 26 26">
                            {{ user.personal_info.phone }}</a
                          ></span
                        >
                      </div>

                      <div class="mb-3">
                        <span class="role-table"> Email</span>

                        <span>
                          <a
                            :href="
                              `https://mail.google.com/mail/?view=cm&fs=1&to=${user.account.email}`
                            "
                          >
                            {{ user.account.email }}</a
                          ></span
                        >
                      </div>

                      <div class="mb-3">
                        <span class="role-table">Address</span>

                        <span class="capitalize d-block">
                          {{ separateWords([user.address.street]) }}
                        </span>
                        <span class="capitalize d-block">
                          {{
                            separateWords([
                              user.address.city,
                              user.address.state
                            ])
                          }}</span
                        >
                        <span class="capitalize d-block">
                          {{
                            separateWords([
                              user.address.country,
                              user.address.postal_code
                            ])
                          }}</span
                        >
                      </div>

                      <div>
                        <span class="role-table"> Hire Date</span>

                        <span>
                          {{ user.agreement.start_date | formatDate }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-9 col-lg-12 col-md-12 col-sm-12 col-12">
          <!-- <b-tabs content-class="mt-3" justified>
            <b-tab title="My Info" active> -->

          <div class="row">
            <div class="col-xl-8">
              <div class="col-xl-12 p-xl-0">
                <div class="card">
                  <h2 class="subtitle mb-4">Personal Info</h2>
                  <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                      <base-input
                        label="First Name"
                        placeholder="First Name"
                        id="first_name_admin"
                        name="first_name_admin"
                        v-model="$v.user.personal_info.first_name.$model"
                        :error="
                          !$v.user.personal_info.first_name.minLength ||
                          $v.user.personal_info.first_name.$error
                            ? `Invalid First Name`
                            : ''
                        "
                        disabled
                      />
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-12">
                      <base-input
                        label="Last Name"
                        placeholder="Last Name"
                        id="last_name_admin"
                        name="last_name_admin"
                        v-model="$v.user.personal_info.last_name.$model"
                        :error="
                          !$v.user.personal_info.last_name.minLength ||
                          $v.user.personal_info.last_name.$error
                            ? `Invalid Last Name`
                            : ''
                        "
                        disabled
                      />
                    </div>
                    <div
                      class="col-xl-4 col-lg-3 col-md-4 col-sm-4 col-12 mb-2"
                    >
                      <label
                        class="title-label"
                        v-bind:class="{
                          'is-invalid': $v.user.personal_info.gender.$error
                        }"
                        ><span class="markrequired">*</span>Gender</label
                      >
                      <div class="">
                        <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                          <b-form-radio-group
                            id="radio-group-2"
                            v-model="$v.user.personal_info.gender.$model"
                            :aria-describedby="ariaDescribedby"
                            name="radio-sub-component"
                            buttons
                            button-variant="outline-neutral"
                            size="md"
                            v-bind:class="{
                              'is-invalid': $v.user.personal_info.gender.$error
                            }"
                          >
                            <b-form-radio value="male">M</b-form-radio>
                            <b-form-radio value="female">F</b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                      <small
                        class="invalid-feedback mt-1"
                        v-if="$v.user.personal_info.gender.$error"
                        >Select Gender</small
                      >
                    </div>

                    <div class="col-xl-5 col-lg-5 col-md-3 col-sm-4 col-12">
                      <base-input
                        label="Date of Birth"
                        v-bind:class="{
                          'is-invalid':
                            $v.user.personal_info.date_of_birth.$error
                        }"
                        :error="
                          $v.user.personal_info.date_of_birth.$error
                            ? `Enter Date of Birth`
                            : ''
                        "
                        markrequired
                      >
                        <flat-picker
                          slot-scope="{ focus, blur }"
                          @on-open="focus"
                          @on-close="blur"
                          :config="{
                            altFormat: formatDateFlatPicker,
                            altInput: true,
                            dateFormat: 'Y-m-d',
                            allowInput: true
                          }"
                          class="input-custom"
                          v-model="$v.user.personal_info.date_of_birth.$model"
                          id="date"
                          name="user_birth"
                          placeholder="-"
                        ></flat-picker>
                      </base-input>
                    </div>

                    <div
                      class="col-xl-7 col-lg-7 col-md-6 col-sm-6 col-12 mb-2"
                    >
                      <label class="title-label">Document Identity</label>
                      <div class="d-flex">
                        <b-form-group
                          v-slot="{ ariaDescribedby2 }"
                          class="d-inline-flex"
                        >
                          <b-form-radio-group
                            v-model="$v.user.personal_info.document.type.$model"
                            :aria-describedby="ariaDescribedby2"
                            id="radio-platform"
                            name="radio-platform"
                            tabindex="7"
                            buttons
                            button-variant="outline-neutral"
                            size="md"
                          >
                            <b-form-radio
                              value="passport"
                              class="pc-1"
                              title="Passport"
                              tabindex="7"
                              >PASS</b-form-radio
                            >
                            <b-form-radio value="dni" class="pc-1" title="DNI"
                              >DNI</b-form-radio
                            >
                          </b-form-radio-group>
                        </b-form-group>

                        <base-input
                          v-model.trim="
                            $v.user.personal_info.document.value.$model
                          "
                          placeholder="Other Contact Info"
                          id="user_type_doc_identity"
                          name="user_type_doc_identity"
                          tabindex="8"
                          class="d-inline-flex"
                        >
                        </base-input>
                      </div>

                      <small
                        class="invalid-feedback w-100"
                        v-if="$v.user.personal_info.document.value.$error"
                        >{{
                          !$v.user.personal_info.document.value.minLength ||
                          $v.user.personal_info.document.value.$error
                            ? `Minimum ${$v.user.personal_info.document.value.$params.minLength.min} letters.`
                            : ""
                        }}</small
                      >
                    </div>

                    <div
                      class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 inputphone mb-2"
                      v-bind:class="{
                        'is-invalid': $v.user.personal_info.phone.$error
                      }"
                    >
                      <label class="title-label"
                        ><span class="markrequired">*</span>Contact
                        Number</label
                      >
                      <vue-tel-input
                        v-model="phoneFormat"
                        key="NumberPhoneuser"
                        inputId="NumberPhoneuser"
                        name="NumberPhoneuser"
                        required
                        mode="international"
                        inputClasses="input no-label no-err"
                        :dynamicPlaceholder="true"
                        :disabledFetchingCountry="true"
                        :validCharactersOnly="true"
                        :wrapperClasses="[
                          $v.user.personal_info.phone.$error
                            ? 'is-invalid'
                            : '',
                          'mb-0'
                        ]"
                        @input="phoneInput"
                      ></vue-tel-input>
                      <small
                        class="invalid-feedback"
                        v-if="$v.user.personal_info.phone.$error"
                        >Enter a valid phone</small
                      >
                    </div>

                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                      <label class="title-label">Other Contact Info</label>
                      <div class="d-flex">
                        <b-form-group
                          v-slot="{ ariaDescribedby2 }"
                          class="d-inline-flex"
                        >
                          <b-form-radio-group
                            id="contact-info"
                            v-model="$v.user.personal_info.contact.type.$model"
                            :aria-describedby="ariaDescribedby2"
                            name="contact-info"
                            buttons
                            button-variant="outline-neutral"
                            size="md"
                          >
                            <b-form-radio
                              value="whatsapp"
                              class="pc-2"
                              title="Whatsapp"
                              tabindex="20"
                              ><i class="flaticon-bold-whatsapp f16"></i
                            ></b-form-radio>
                            <b-form-radio
                              value="skype"
                              class="pc-2"
                              title="Skype"
                              ><i
                                class="flaticon-bold-logotipo-de-skype f16"
                              ></i
                            ></b-form-radio>
                          </b-form-radio-group>
                        </b-form-group>

                        <base-input
                          v-model.trim="user.personal_info.contact.value"
                          placeholder="Other Contact Info"
                          id="passengers_phone_optional"
                          name="passengers_phone_optional"
                          class="d-inline-flex"
                        >
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-12 p-xl-0">
                <div class="card">
                  <h2 class="subtitle mb-4">Address Info</h2>
                  <div class="row">
                    <div class="col-xl-7 col-lg-7 col-md-4 col-sm-4 col-12">
                      <base-input
                        id="user_street"
                        name="user_street"
                        label="Street address, apartment, suite, etc."
                        placeholder="Street"
                        v-model="$v.user.address.street.$model"
                        :error="
                          !$v.user.address.street.minLength ||
                          $v.user.address.street.$error
                            ? `Minimum ${$v.user.address.street.$params.minLength.min} letters.`
                            : ''
                        "
                      />
                    </div>

                    <div class="col-xl-5 col-lg-5 col-md-4 col-sm-4 col-12">
                      <base-input
                        id="user_city"
                        name="user_city"
                        label="City"
                        placeholder="City"
                        v-model="$v.user.address.city.$model"
                        :error="
                          !$v.user.address.city.minLength ||
                          $v.user.address.city.$error
                            ? `Minimum ${$v.user.address.city.$params.minLength.min} letters.`
                            : ''
                        "
                      />
                    </div>

                    <div class="col-xl-7 col-lg-7 col-md-4 col-sm-4 col-12">
                      <base-input
                        id="user_state"
                        name="user_state"
                        label="State/Province/Region"
                        placeholder="State"
                        v-model="$v.user.address.state.$model"
                        :error="
                          !$v.user.address.state.minLength ||
                          $v.user.address.state.$error
                            ? `Minimum ${$v.user.address.state.$params.minLength.min} letters.`
                            : ''
                        "
                      />
                    </div>

                    <div class="col-xl-5 col-lg-5 col-md-4 col-sm-4 col-12">
                      <base-input
                        id="user_zipcode"
                        name="user_zipcode"
                        label="Zip Code"
                        placeholder="Zip Code"
                        v-model.trim="$v.user.address.postal_code.$model"
                        type="text"
                        :error="
                          !$v.user.address.postal_code.minLength ||
                          $v.user.address.postal_code.$error
                            ? `Minimum ${$v.user.address.postal_code.$params.minLength.min} letters.`
                            : ''
                        "
                      />
                    </div>

                    <div
                      class="col-xl-6 col-lg-6 col-md-4 col-sm-4 col-12 mb-2"
                    >
                      <WSelect
                        v-bind:class="{
                          'invalid-feedback': $v.user.address.country.$error
                        }"
                        id="user_country"
                        name="user_country"
                        filterable
                        remote
                        reserve-keyword
                        :remote-method="remoteMethod"
                        :loading="loading"
                        placeholder="Enter a Country"
                        v-model="$v.user.address.country.$model"
                        label="Country"
                        markrequired
                      >
                        <el-option
                          v-for="country in options"
                          :value="country.name"
                          :label="country.name"
                          :key="country.name"
                        ></el-option>
                      </WSelect>
                      <small
                        class="invalid-feedback"
                        v-if="$v.user.address.country.$error"
                        >Enter a Country</small
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-4 p-xl-0">
              <div class="card">
                <h2 class="subtitle mb-4">Account info</h2>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                    <base-input
                      label="Email"
                      placeholder="example@email.com"
                      id="email_admin"
                      name="email_admin"
                      v-model="$v.user.account.email.$model"
                      type="email"
                      disabled
                      :error="
                        !$v.user.account.email
                          ? `Please Enter a valid email.`
                          : ''
                      "
                    />
                  </div>

                  <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      v-model="$v.user.account.password.$model"
                      label="Password"
                      placeholder="Password"
                      id="password_admin_profile"
                      name="password_admin_profile"
                      :type="typePassword"
                      autocomplete="new-password"
                      maxlength="20"
                      class="input-append"
                      :error="
                        showMessageErrorPassword($v.user.account.password)
                      "
                      :successMessage="'Strong Password'"
                      :valid="
                        $v.user.account.password.strongPassword &&
                          $v.user.account.password.$model !== ''
                      "
                      :tooltip="true"
                      titleTooltip='<i class="flaticon-lock mr-2"></i><strong>Strong Password</strong>'
                      contentTooltip='<ul class="ul-pop">
                                  <li>Minimum 8 characters</li>
                                  <li>1 Uppercase Letter</li>
                                  <li>1 Lowercase Letter</li>
                                  <li>1 Number</li>
                                  <li>1 Special Character (Ex. @ # $ %)</li>
                                </ul>'
                      ><template slot="append">
                        <span @click="seePassword()" class="icon-button"
                          ><i
                            v-bind:class="{
                              'flaticon-view-1': typePassword == 'password',
                              'flaticon-hidden': typePassword == 'text'
                            }"
                          ></i
                        ></span>
                      </template>
                    </base-input>
                  </div>
                  <div class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12">
                    <base-input
                      label="Password Confirm"
                      placeholder="Password Confirm"
                      id="repeat_password_admin_profile"
                      name="repeat_password_admin_profile"
                      v-model="$v.repeatPassword.$model"
                      type="password"
                      :error="
                        !$v.repeatPassword.sameAsPassword ||
                        $v.repeatPassword.$error
                          ? `Passwords must be identical.`
                          : ''
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- </b-tab> -->
          <!-- <b-tab title="My Settings">
              <base-alert type="secondary" class="alert-box">
                <h2><strong>Coming Soon!</strong></h2>

                Here you will find your settings.

                <img
                  src="../../assets/images/character/waiting.png"
                        alt="RhomTrip Timer"
                  class="logo-home"
                />
              </base-alert> -->
          <!-- <div class="col-12 alinmov3">
                <div class="box-buttons">
                  <base-button type="primary" class="min-button">
                    <i class="flaticon-floppy-disk"></i>Apply changes
                  </base-button>
                </div>
              </div>

              <div class="col-8">
                <div class="card">
                  <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                      <div
                        v-bind:style="{
                          backgroundImage: `url(/img/themes/default.png)`,
                        }"
                        class="previewTheme"
                      ></div>
                      <div class="radio-theme mt-1 text-center">
                        <base-radio
                          name="default"
                          class="ml-2"
                          v-model="themes.option"
                          value="default"
                          >Default</base-radio
                        >
                      </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                      <div class="previewTheme">
                        <svg
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="100%"
                          height="200px"
                          viewBox="0 0 236 177"
                          enable-background="new 0 0 236 177"
                          xml:space="preserve"
                        >
                          <rect
                            x="7.331"
                            y="18.169"
                            opacity="0.4"
                            fill="#AAAAAA"
                            width="212.665"
                            height="150.67"
                          />
                          <rect
                            x="13.333"
                            y="13.167"
                            fill="#EFEFF2"
                            width="212.667"
                            height="150.667"
                          />
                          <rect
                            x="11"
                            y="13"
                            fill="#FFFFFF"
                            width="12.667"
                            height="150.667"
                          />
                          <circle
                            fill="none"
                            :stroke="themes.color"
                            stroke-miterlimit="10"
                            cx="17.331"
                            cy="40.997"
                            r="4"
                          />
                          <circle
                            :fill="themes.color"
                            cx="211.496"
                            cy="36.997"
                            r="4"
                          />
                          <circle
                            fill="none"
                            :stroke="themes.color"
                            stroke-miterlimit="10"
                            cx="17.333"
                            cy="53.118"
                            r="4"
                          />
                          <circle
                            fill="none"
                            :stroke="themes.color"
                            stroke-miterlimit="10"
                            cx="17.333"
                            cy="65.121"
                            r="4"
                          />
                          <circle
                            fill="none"
                            :stroke="themes.color"
                            stroke-miterlimit="10"
                            cx="17.333"
                            cy="76.333"
                            r="4"
                          />
                          <rect
                            x="11"
                            y="13"
                            :fill="themes.color"
                            width="214.335"
                            height="15.333"
                          />
                          <g id="Layer_6">
                            <g id="Layer_2">
                              <path
                                fill="#FFFFFF"
                                d="M120,84.229c0,1.862-1.921,3.371-4.291,3.371h29.624c-2.37,0-4.291-1.509-4.291-3.371V48.727
                              c0-1.861,1.921-3.371,4.291-3.371h76.085c2.37,0,4.291,1.509,4.291,3.371V84.229z"
                              />
                              <line
                                fill="#3F4F99"
                                :stroke="themes.color"
                                stroke-miterlimit="10"
                                x1="35.333"
                                y1="45.354"
                                x2="120"
                                y2="45.354"
                              />
                              <rect
                                x="39.667"
                                y="53.975"
                                fill="#EFEFF2"
                                width="39"
                                height="5"
                              />
                              <rect
                                x="85.666"
                                y="53.974"
                                fill="#EFEFF2"
                                width="29.667"
                                height="5"
                              />
                              <rect
                                x="39.833"
                                y="64.979"
                                fill="#EFEFF2"
                                width="39.001"
                                height="5"
                              />
                              <rect
                                x="85.833"
                                y="64.978"
                                fill="#EFEFF2"
                                width="29.668"
                                height="5"
                              />
                              <rect
                                x="39.834"
                                y="75.191"
                                fill="#EFEFF2"
                                width="39"
                                height="5"
                              />
                              <rect
                                x="85.832"
                                y="75.19"
                                fill="#EFEFF2"
                                width="29.668"
                                height="5.001"
                              />
                            </g>
                            <g id="Layer_3">
                              <path
                                fill="#FFFFFF"
                                d="M214.666,84.229c0,1.862-1.92,3.371-4.29,3.371h-76.085c-2.37,0-4.291-1.509-4.291-3.371V48.727
                              c0-1.861,1.921-3.371,4.291-3.371h76.085c2.37,0,4.29,1.509,4.29,3.371V84.229z"
                              />
                              <line
                                fill="#3F4F99"
                                :stroke="themes.color"
                                stroke-miterlimit="10"
                                x1="130"
                                y1="45.354"
                                x2="214.666"
                                y2="45.354"
                              />
                              <rect
                                x="134.334"
                                y="53.975"
                                fill="#EFEFF2"
                                width="39"
                                height="5"
                              />
                              <rect
                                x="180.332"
                                y="53.974"
                                fill="#EFEFF2"
                                width="29.668"
                                height="5"
                              />
                              <rect
                                x="134.5"
                                y="64.979"
                                fill="#EFEFF2"
                                width="39.001"
                                height="5"
                              />
                              <rect
                                x="180.499"
                                y="64.978"
                                fill="#EFEFF2"
                                width="29.668"
                                height="5"
                              />
                              <rect
                                x="134.5"
                                y="75.191"
                                fill="#EFEFF2"
                                width="39"
                                height="5"
                              />
                              <rect
                                x="180.498"
                                y="75.19"
                                fill="#EFEFF2"
                                width="29.668"
                                height="5.001"
                              />
                              <rect
                                x="35.333"
                                y="34.997"
                                fill="#060606"
                                width="43.501"
                                height="4"
                              />
                              <path
                                opacity="0.4"
                                fill="#FFFFFF"
                                d="M90.001,20.667c0,1.312-0.896,2.375-2,2.375h28.5c-1.104,0-2-1.063-2-2.375l0,0
                              c0-1.312,0.896-2.375,2-2.375h29.501C89.105,18.292,90.001,19.355,90.001,20.667L90.001,20.667z"
                              />
                              <rect
                                x="17.335"
                                y="18.292"
                                fill="#FFFFFF"
                                width="22"
                                height="4.75"
                              />
                            </g>
                            <g id="Layer_4">
                              <path
                                fill="#FFFFFF"
                                d="M214.666,132.273c0,1.863-1.92,3.373-4.29,3.373h-76.085c-2.37,0-4.291-1.51-4.291-3.373v-35.52
                              c0-1.862,1.921-3.372,4.291-3.372h76.085c2.37,0,4.29,1.51,4.29,3.372V132.273z"
                              />
                              <line
                                fill="#3F4F99"
                                :stroke="themes.color"
                                stroke-miterlimit="10"
                                x1="130"
                                y1="93.38"
                                x2="214.666"
                                y2="93.38"
                              />
                              <rect
                                x="134.334"
                                y="102.005"
                                fill="#EFEFF2"
                                width="39"
                                height="5.002"
                              />
                              <rect
                                x="180.332"
                                y="102.004"
                                fill="#EFEFF2"
                                width="29.668"
                                height="5.003"
                              />
                              <rect
                                x="134.5"
                                y="113.014"
                                fill="#EFEFF2"
                                width="39.001"
                                height="5.003"
                              />
                              <rect
                                x="180.499"
                                y="113.014"
                                fill="#EFEFF2"
                                width="29.668"
                                height="5.003"
                              />
                              <rect
                                x="134.5"
                                y="123.231"
                                fill="#EFEFF2"
                                width="39"
                                height="5.003"
                              />
                              <rect
                                x="180.498"
                                y="123.23"
                                fill="#EFEFF2"
                                width="29.668"
                                height="5.004"
                              />
                            </g>
                            <path
                              fill="#FFFFFF"
                              d="M120,132.26c0,1.862-1.92,3.371-4.29,3.371h29.625c-2.37,0-4.291-1.509-4.291-3.371V96.758
                            c0-1.861,1.921-3.371,4.291-3.371h76.085c2.37,0,4.29,1.51,4.29,3.371V132.26z"
                            />
                            <line
                              fill="#3F4F99"
                              :stroke="themes.color"
                              stroke-miterlimit="10"
                              x1="35.334"
                              y1="93.385"
                              x2="120"
                              y2="93.385"
                            />
                            <rect
                              x="39.668"
                              y="102.006"
                              fill="#EFEFF2"
                              width="39"
                              height="5"
                            />
                            <rect
                              x="85.666"
                              y="102.006"
                              fill="#EFEFF2"
                              width="29.668"
                              height="5"
                            />
                            <rect
                              x="39.834"
                              y="113.01"
                              fill="#EFEFF2"
                              width="39.001"
                              height="5"
                            />
                            <rect
                              x="85.833"
                              y="113.01"
                              fill="#EFEFF2"
                              width="29.668"
                              height="5"
                            />
                            <rect
                              x="39.834"
                              y="123.223"
                              fill="#EFEFF2"
                              width="39"
                              height="5"
                            />
                            <rect
                              x="85.832"
                              y="123.222"
                              fill="#EFEFF2"
                              width="29.668"
                              height="5.001"
                            />
                            <g id="Layer_5" />
                          </g>
                          <circle
                            fill="#FFFFFF"
                            cx="195.494"
                            cy="20.667"
                            r="4"
                          />
                          <rect
                            x="204.995"
                            y="19.292"
                            fill="#FFFFFF"
                            width="14.334"
                            height="2.375"
                          />
                        </svg>
                      </div>

                      <div class="text-center">
                        <div class="form__field">
                          <div class="form__label radio-theme">
                            <base-radio
                              name="custom"
                              class="ml-2"
                              v-model="themes.option"
                              value="custom"
                              >Custom Color</base-radio
                            >
                          </div>
                          <el-tooltip content="Select Color" placement="top">
                            <div class="form__input ml-4">
                              <v-swatches
                                v-model="themes.color"
                                :swatches="colors"
                                close-on-select
                                popover-x="left"
                                swatch-size="28"
                                row-length="8"
                                shapes="circles"
                                :trigger-style="{
                                  width: '25px',
                                  height: '25px',
                                  borderRadius: '50%',
                                  display: 'flex',
                                }"
                              ></v-swatches>
                            </div>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
          <!-- </b-tab>
            <b-tab title="My Dashboard">
              <base-alert type="secondary" class="alert-box">
                <h2><strong>Coming Soon!</strong></h2>

                Here you will find your metrics and statistics.

                <img
                  src="../../assets/images/character/waiting.png"
                        alt="RhomTrip Timer"
                  class="logo-home"
                />
              </base-alert> -->
          <!-- <div class="row">
                <div class="col-12 text-right mb-3">
                  <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                    <b-form-radio-group
                      id="radio-group-2"
                      v-model="filter"
                      :aria-describedby="ariaDescribedby"
                      name="radio-sub-component"
                      buttons
                      button-variant="outline-neutral"
                      size="md"
                      @change="initBigChart()"
                    >
                      <b-form-radio value="0">Day</b-form-radio>
                      <b-form-radio value="1">Week</b-form-radio>
                      <b-form-radio value="2">Month</b-form-radio>
                      <b-form-radio value="3">Year</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
                <div class="col-xl-4">
                  <stats-card
                    title="New Reservations"
                    type="two"
                    sub-title="200"
                    icon="flaticon-calendar"
                  >
                    <template slot="footer">
                      <span class="text-success mr-2">
                        <i class="flaticon-up-1"></i> 3.48%
                      </span>

                      <span class="text-danger mr-2">
                        <i class="flaticon-down"></i> 3.48%
                      </span>
                      <span class="text-nowrap">Since last month</span>
                    </template>
                  </stats-card>
                </div>
                <div class="col-xl-4">
                  <stats-card
                    title="New Customers"
                    type="six"
                    sub-title="200"
                    icon="flaticon-team"
                  >
                    <template slot="footer">
                      <span class="text-success mr-2">
                        <i class="flaticon-up-1"></i> 3.48%
                      </span>

                      <span class="text-danger mr-2">
                        <i class="flaticon-down"></i> 3.48%
                      </span>
                      <span class="text-nowrap">Since last month</span>
                    </template>
                  </stats-card>
                </div>
                <div class="col-xl-4">
                  <stats-card
                    title="Cancelations"
                    type="four"
                    sub-title="200"
                    icon="flaticon-remove"
                  >
                    <template slot="footer">
                      <span class="text-success mr-2">
                        <i class="flaticon-up-1"></i> 3.48%
                      </span>

                     <span class="text-danger mr-2">
                        <i class="flaticon-down"></i> 3.48%
                      </span>
                      <span class="text-nowrap">Since last month</span>
                    </template>
                  </stats-card>
                </div>
                <div class="col-xl-12">
                  <card type="default" header-classes="bg-transparent">
                    <div slot="header" class="row align-items-center">
                      <div class="col">
                        <h6 class="text-light text-uppercase ls-1 mb-1">
                          Overview
                        </h6>
                        <h5 class="h2 mb-0">New Reservations</h5>
                      </div>
                    </div>
                    <line-chart
                      :height="350"
                      ref="bigChart"
                      :chart-data="allReservationChart.chartData"
                      :extra-options="allReservationChart.extraOptions"
                    ></line-chart>
                  </card>
                </div>
              </div> -->
          <!-- </b-tab>
            <b-tab title="My insights">
              <base-alert type="secondary" class="alert-box">
                <h2><strong>Coming Soon!</strong></h2>

                Here you will find your achievements and rewards.

                <img
                  src="../../assets/images/character/waiting.png"
                        alt="RhomTrip Timer"
                  class="logo-home"
                />
              </base-alert> -->

          <!-- <vue-ellipse-progress
                :data="circles"
                :progress="(reservationsAmount * 100) / 200"
                color="#7579ff"
                empty-color="#324c7e"
                :size="180"
                :thickness="5"
                :empty-thickness="3"
                lineMode="in 10"
                :legend="true"
                :legendValue="reservationsAmount"
                :legendFormatter="
                  ({ currentValue }) =>
                    new Intl.NumberFormat('en-US').format(currentValue)
                "
                legendClass="legend-custom-style"
                dash="5"
                animation="loop 700 1000"
                :noData="false"
                :loading="false"
                fontColor="black"
                :half="false"
                :max="progressInsight[0].max"
              >
                <span slot="legend-value" class="ep-legend--value__counter"
                  >/{{ progressInsight[0].max }}</span
                >
                <p slot="legend-caption">{{ progressInsight[0].name }}</p>
              </vue-ellipse-progress> -->
          <!-- </b-tab>
          </b-tabs> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import { ProfilesAPI } from "../../core/api";
import Swal from "sweetalert2";
import {
  required,
  minLength,
  maxLength,
  email,
  sameAs
} from "vuelidate/lib/validators";
import { helpers } from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import WSelect from "@/components/Select";
import { VueTelInput } from "vue-tel-input";
import moment from "moment";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import VSwatches from "vue-swatches";
import lodash from "lodash";
import { goBack, removeCredentials } from "../../helpers/commons.helpers";
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "user-profile",
  components: {
    WSelect,
    // LineChart,
    // VueEllipseProgress,
    flatPicker,
    VueTelInput,
    VSwatches
  },
  data() {
    return {
      user: {
        personal_info: {
          first_name: "",
          last_name: "",
          phone: "",
          gender: "",
          date_of_birth: "",
          document: {
            type: "",
            value: ""
          },
          contact: {
            type: "",
            value: ""
          }
        },
        account: {
          email: "",
          password: ""
        },
        profile: {
          image: "",
          status: true
        },
        relationship: {
          owner: "",
          type: ""
        },
        address: {
          country: "",
          state: "",
          city: "",
          street: "",
          postal_code: ""
        },
        agreement: {
          start_date: "",
          end_date: "",
          position: "",
          notes: ""
        }
      },
      repeatPassword: "",
      url_picture: "",
      loading: false,
      options: [],
      userCopy: {},
      createClock: null,
      filter: 1,
      start: "",
      end: "",
      filtercustom: false,
      allReservationChart: {
        //DATA ONLY RESERVATIONS SUCCESS
        allData: [
          [5, 30, 10, 40, 30, 15, 40, 20, 60, 10, 5], //DAY
          [5, 20, 5, 25, 10, 30, 15], //WEEK
          [30, 5, 25, 10, 30, 40, 40], //MONTH
          [30, 360, 5, 25, 10, 30, 15, 40, 40, 100, 50, 200] //YEAR
        ],

        labels: [
          [
            "02:00",
            "04:00",
            "06:00",
            "08:00",
            "10:00",
            "13:00",
            "15:00",
            "17:00",
            "19:00",
            "21:00",
            "23:00"
          ],
          ["Sun", "Mon", "Tue", "Wen", "Thu", "Fri", "Sat"],
          ["01", "05", "10", "15", "20", "25", "30"],
          [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ]
        ],

        activeIndex: 0,
        chartData: {
          datasets: [],
          labels: []
        }
        // extraOptions: chartConfigs.blueChartOptions,
      },
      circles: [1],
      reservationsAmount: 120,
      progressInsight: [
        { max: 500, name: "Semi Baby" },
        { max: 1000, name: "Baby" },
        { max: 2000, name: "Semi God" },
        { max: 3000, name: "God" },
        { max: 5000, name: "Super Sayayin" }
        // Mouse pad
        // llavero
        // taza
        // lapicero
        // cooler
      ],
      contact_platform: [
        { value: "whatsapp", label: "Whatsapp" },
        { value: "skype", label: "Skype" }
      ],
      genderOptions: [
        { value: "male", label: "Male" },
        { value: "female", label: "Female" }
      ],
      typeDocOptions: [
        { value: "passport", label: "PASS" },
        { value: "dni", label: "DNI" }
      ],
      themes: {
        option: "default",
        color: "#8E43AD"
      },
      colors: [
        "#000000",
        "#666666",
        "#999999",
        "#980000",
        "#cc0000",
        "#f60000",
        "#E84B3C",
        "#e69138",
        "#F39C19",
        "#FFBB00",
        "#133217",
        "#028900",
        "#6aa84f",
        "#45818e",
        "#3c78d8",
        "#3F2AD4",
        "#25197F",
        "#0A0055",
        "#674ea7",
        "#8E43AD",
        "#A463BF",
        "#a64d79",
        "#CC0254",
        "#FF00A7"
      ],
      last_name: "",
      first_name: "",
      userId: "",
      onSaved: false,
      disabledButtonSaveProfile: false,
      phoneFormat: "",
      typePassword: "password",
      imgprofile: require("rhomtrip_assets/src/img/users/user-placeholder.png")
    };
  },
  async created() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },

      {
        text: "My Profile",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.getGlobalCountries();
    if (this.sesion === null) {
      this.getSesion();
    }
    this.userId = this.sesion.id;
    await this.getUser(this.sesion.id, this.userId);
  },
  watch: {
    "user.personal_info": {
      handler: function(current, old) {
        this.last_name = current.last_name;
        this.first_name = current.first_name;
      },
      deep: true
    }
  },
  methods: {
    async getUser(userId) {
      try {
        this.setLoad(true);
        let { data } = await ProfilesAPI.getProfileUser(
          userId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let user = data.data;
          this.user.personal_info.first_name = user.personal_info.first_name;
          this.first_name = this.user.personal_info.first_name;
          this.user.personal_info.last_name = user.personal_info.last_name;
          this.last_name = this.user.personal_info.last_name;
          this.user.personal_info.phone = user.personal_info.phone;
          this.user.personal_info.gender = user.personal_info.gender;

          this.user.personal_info.date_of_birth = moment(
            user.personal_info.date_of_birth
          )
            .utc(false)
            .format("YYYY-MM-DD");

          this.user.personal_info.document.type =
            user.personal_info.document.type;
          this.user.personal_info.document.value =
            user.personal_info.document.value;

          this.user.personal_info.contact.type =
            user.personal_info.contact.type;
          this.user.personal_info.contact.value =
            user.personal_info.contact.value;

          this.user.personal_info.contact.type =
            user.personal_info.contact.type;
          this.user.personal_info.contact.value =
            user.personal_info.contact.value;

          this.phoneFormat = user.personal_info.phone;
          this.user.account.email = user.account.email;
          this.user.profile.image = user.profile.image;
          this.user.profile.status = user.profile.status;
          this.url_picture = this.user.profile.image;

          this.user.address.country = user.address.country;
          this.user.address.state = user.address.state;
          this.user.address.city = user.address.city;
          this.user.address.street = user.address.street;
          this.user.address.postal_code = user.address.postal_code;

          this.user.agreement.start_date = user.agreement.start_date;
          this.user.agreement.end_date = user.agreement.end_date;
          this.user.agreement.position = user.agreement.position;
          this.user.agreement.notes = user.agreement.notes;

          this.userCopy = lodash.cloneDeep(this.user);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "Could not load data. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "Could not load data. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          this.options = this.countries.filter(country => {
            return country.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
          });
        }, 200);
      } else {
        this.options = [];
      }
    },
    async saveProfile(route = null) {
      if (!this.$v.user.$invalid && !this.$v.repeatPassword.$invalid) {
        let user = lodash.cloneDeep(this.user);
        await this.updateProfile(this.userId, user, route);
      } else {
        this.$v.repeatPassword.$touch();
        this.$v.user.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async updateProfile(userId, user, route) {
      let { value } = await Swal.fire({
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        title: `Confirm Save`,
        html: "Are you sure you update your profile?",
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",
        confirmButtonClass: "btn btn-primary btn-small-one"
      });
      if (value) {
        await this.updateUuserById(userId, user, route);
      }
    },
    async updateUuserById(userId, user, route) {
      try {
        this.setLoad(true);
        this.disabledButtonSaveProfile = true;
        let { data } = await ProfilesAPI.updateProfile(
          userId,
          user,
          this.sesion.token
        );
        this.setLoad(false);
        this.disabledButtonSaveProfile = false;
        this.onSaved = true;
        if (data.status) {
          if (this.user.account.password) {
            this.logOut(route);
            this.$notify({
              type: "success",
              title: "Success!",
              message: "The Profile has been Updated",
              icon: "ni ni-check-bold"
            });
          } else {
            this.setProfile({
              first_name: this.first_name,
              last_name: this.last_name,
              url_picture: this.url_picture,
              status: true
            });
            this.$notify({
              type: "success",
              title: "Success!",
              message: "The Profile has been Updated",
              icon: "ni ni-check-bold"
            });
            this.$router.push({ path: route ? route : "/my-profile" });
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not saved. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.disabledButtonSaveProfile = false;
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not saved. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    showMessageErrorPassword($password) {
      if (!$password.minLength) {
        return `Password must have at least ${$password.$params.minLength.min} letters.`;
      } else if (!$password.strongPassword && $password.$model !== "") {
        return "Invalid Password";
      } else {
        return "";
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    change(filter) {
      this.filter = filter;
      this.setLoad(true);
      if (this.createClock === null) {
        // this.initData(this.filter);
        this.createClock = setInterval(() => {
          // this.initData(this.filter);
        }, 10000);
      } else {
        clearInterval(this.createClock);
        // this.initData(this.filter);
        this.createClock = setInterval(() => {
          // this.initData(this.filter);
        }, 10000);
      }
    },
    initBigChart(index) {
      let chartData = {
        datasets: [
          {
            label: "Reservations",
            data: this.allReservationChart.allData[this.filter]
          }
        ],

        labels: this.allReservationChart.labels[this.filter]
      };
      this.allReservationChart.chartData = chartData;
      this.allReservationChart.activeIndex = this.filter;
    },
    initData(filter) {
      this.getIncome(filter);
    },
    phoneInput(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.user.personal_info.phone = result.number.e164;
      } else {
        this.user.personal_info.phone = result.number.e164;
      }
    },
    separateWords(words = []) {
      return words.filter(word => word).join(", ");
    },
    logOut(route) {
      document.body.style.removeProperty("--primary-tooltip");
      this.setResponseReservations({});
      this.setDrivers({});
      this.setOperatorRespose({});
      this.setResponseBranch({});
      this.setResponseArea({});
      this.setVehicles({});
      removeCredentials();
      this.setSesion(null);
      this.$router.push({ path: route ? route : "/signin" });
    },
    seePassword() {
      this.typePassword = this.typePassword == "password" ? "text" : "password";
    },
    ...mapActions(["getGlobalCountries", "getSesion"]),
    ...mapMutations([
      "setProfile",
      "setLoad",
      "setItemsBread",
      "setResponseReservations",
      "setDrivers",
      "setOperatorRespose",
      "setResponseBranch",
      "setResponseArea",
      "setVehicles",
      "setSesion"
    ])
  },
  computed: {
    formatDateFlatPicker: function() {
      return "d-M-Y";
    },
    ...mapGetters(["countries", "sesion", "load"])
  },
  filters: {
    typeUser: function(type) {
      if (type === "admin") {
        return "Admin";
      } else if (type === "super_admin") {
        return "Super Admin";
      } else if (type === "manager") {
        return "Manager";
      } else if (type === "user") {
        return "User";
      }
    },
    typePosition: function(type) {
      if (type === "administration-finance") {
        return " Administration & Finance";
      } else if (type === "co-founder-cto") {
        return "Co-Founder & CTO";
      } else if (type === "co-founder-coo") {
        return "Co-Founder & COO";
      } else if (type === "co-founder-ceo") {
        return "Co-Founder & CEO";
      } else if (type === "customer-service-representative") {
        return "Customer Service Representative";
      } else if (type === "data-entry-operator") {
        return "Data Entry Operator";
      } else if (type === "designer-front-end") {
        return "Designer & Front End";
      } else if (type === "developer") {
        return "Developer";
      } else if (type === "junior-reservations-sales-agent") {
        return "Junior Reservations & Sales Agent";
      } else if (type === "product-manager") {
        return "Product Manager";
      } else if (type === "reservations-csr-manager") {
        return "Reservations & CSR Manager";
      } else if (type === "reservations-sales-agent") {
        return "Reservations & Sales Agent";
      } else if (type === "sales-manager") {
        return "Sales Manager";
      } else if (type === "account-manager") {
        return "Account Manager";
      } else {
        return "Unkanow";
      }
    },
    gender: function(type) {
      if (type === "male") {
        return "Male";
      } else if (type === "female") {
        return "Female";
      } else {
        return "Other";
      }
    },
    formatDate: function(type) {
      return moment
        .parseZone(type)
        .utc(true)
        .format("DD-MMM-YYYY");
    }
  },
  validations: {
    user: {
      personal_info: {
        first_name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(45),
          ValName
        },
        last_name: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(45),
          ValName
        },
        gender: {
          required
        },
        date_of_birth: {
          required
        },
        document: {
          type: {
            required: false
          },
          value: {
            minLength: minLength(3),
            maxLength: maxLength(45)
          }
        },
        contact: {
          type: {
            required: false
          }
        },
        phone: {
          required,
          minLength: minLength(7),
          maxLength: maxLength(25)
        }
      },
      address: {
        country: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(70)
        },
        city: {
          minLength: minLength(3)
        },
        state: {
          minLength: minLength(3)
        },
        postal_code: {
          minLength: minLength(4)
        },
        street: {
          minLength: minLength(3)
        }
      },
      agreement: {
        position: {
          required
        },
        start_date: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(45)
        },
        end_date: {
          minLength: minLength(3),
          maxLength: maxLength(45)
        },
        notes: {
          maxLength: maxLength(200)
        }
      },
      account: {
        password: {
          required: false,
          minLength: minLength(8),
          strongPassword(password) {
            if (password === "") {
              return true;
            } else {
              return (
                /[a-z]/.test(password) && // checks for a-z
                /[A-Z]/.test(password) && // checks for A-Z
                /[0-9]/.test(password) && // checks for 0-9
                /\W|_/.test(password) && // checks for special char
                password.length >= 8
              );
            }
          }
        },
        email: {
          required,
          email
        }
      },
      relationship: {
        type: {
          required
        }
      }
    },
    repeatPassword: {
      sameAsPassword: sameAs(function() {
        return this.user.account.password;
      })
    }
  },
  mounted() {
    // this.initBigChart(0);
  },
  beforeRouteLeave(to, from, next) {
    let isEqual = lodash.isEqual(this.user, this.userCopy);
    if (!isEqual && !this.onSaved) {
      Swal.fire({
        title: "Important",
        html: "The member has been modified. <br> Do you want to save changes?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "Cancel",

        confirmButtonText: "Yes",
        confirmButtonClass: "btn btn-primary btn-small-one"
      }).then(result => {
        if (result.value) {
          this.saveProfile(to.path);
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          next();
        }
      });
    } else {
      next();
    }
  }
};
</script>
